<template>
  <div class="wrap">
    <Drawer title="上传资源" :visible="visible" :before-close="close" :wrapper-closable="false" v-loading.fullscreen.lock="loading">
      <template v-slot:default>
        <el-form :model="form" :rules="rules" ref="form" label-width="120px" label-position="top">
          <el-form-item label="资源名称" prop="name">
            <el-input v-model="form.name" placeholder="请输入资源名称"></el-input>
          </el-form-item>
          <el-form-item label="上传资源文件" prop="cdn_url">
            <el-upload
              class="upload-demo"
              action=""
              :on-remove="handleUploadRemove"
              :http-request="handleRequest"
              :file-list="fileList"
              :limit="1"
              :on-exceed="handleOnExceed"
            >
              <el-button size="small" type="primary" icon="el-icon-upload2" :disabled="fileList.length">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="资源备注" prop="remark">
            <el-input type="textarea" v-model="form.remark" :rows="5"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button class="drawer-footer-btn" type="primary" @click="submitForm">保存</el-button>
        <el-button class="drawer-footer-btn" @click="close">返回</el-button>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/drawer';
import { CosMixin } from '@/mixins/cos';
import { cloneDeep } from 'lodash';
import { addCdnResource } from '@/graphql/api/cdn_resource';

const defaultForm = {
  name: '',
  cdn_url: '',
  remark: '',
};

export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  mixins: [CosMixin],
  props: {
    row: { type: Object, default: () => {} },
    type: { type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: cloneDeep(defaultForm),
      fileList: [],
      rules: {
        name: [{ required: true, message: '请输入资源名称', trigger: 'blur' }],
        cdn_url: [{ required: true, message: '请上传资源文件', trigger: 'change' }],
      },
      loading: false,
    };
  },
  watch: {
    visible() {
      this.$refs?.form?.clearValidate();
      if (this.visible) {
        this.form = cloneDeep(defaultForm);
        this.fileList = [];
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    async handleRequest(file) {
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      // 截取文件类型
      const lastPointIndex = rs.lastIndexOf('.');
      const suffix = rs.substring(lastPointIndex);
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
        suffix,
      };
      try {
        this.loading = true;
        const res = await this.putCosObject(cosParams);
        this.fileList.push({
          name: res.data,
          url: res.data,
          role: null,
          package: null,
          path: null,
        });
        this.$set(this.form, 'cdn_url', res.data);
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$message('上传失败，请稍后再试');
      }
    },
    handleUploadRemove() {
      this.fileList = [];
      this.$set(this.form, 'cdn_url', '');
    },
    handleOnExceed() {
      this.$message.error('只能上传一个文件');
    },
    handleClose(tag) {
      this.form.tags.splice(this.form.tags.indexOf(tag), 1);
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          const formData = cloneDeep(this.form);
          console.log('submit data: ', formData);
          addCdnResource(formData)
            .then((res) => {
              console.log('%c Line:154 🥕 res', 'color:#42b983', res);
              this.$emit('refresh');
              this.$message.success('上传资源成功');
              this.close();
            })
            .catch(() => {
              this.$message.error('上传资源失败');
            });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
@import '@/styles/element/form.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/checkbox.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';
@import '@/styles/element/tag.scss';
@import '@/styles/element/datapicker.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
}
.select {
  width: 100%;
}
.form-title {
  padding-bottom: 4px;
  color: #384050;
  font-weight: 400;
  line-height: 32px;
}
.wrap {
  ::v-deep {
    .el-card {
      margin-bottom: 16px;
    }
    .el-card__body {
      padding-bottom: 12px;
    }
  }
}
.mini-button {
  min-height: auto;
}
</style>
